import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Database} from '../model/database/database';
import {ProjectService} from '../project/project.service';
import {DbTableDefinitionComponent} from '../dbTableDefinition/dbTableDefinition.component';
import {GenericModalComponent} from '../modal/generic-modal.component';


@Component({
    selector: 'database-creator',
    template: `
        <div class="panel panel-default" style="padding: 10px;margin-top: 120px;">
            <h5><span><img class="dbImage" src="../../assets/images/database.png" alt="icon"></span>Database Definition</h5>
            <div class="card col-md-12" style="border-color:#19A9E5;">
                <div class="card-body">
                    <button data-toggle="collapse" href="#emailConditions" role="button" aria-expanded="false"
                            aria-controls="emailConditions" type="button" class="btn btn-info ">Manage Database
                    </button>
                    <div class="collapse" id="emailConditions">
                        <button type="button" class="btn btn-success btn-sm" data-toggle="tooltip" data-placement="bottom"
                                title="Create Table" (click)="onCreateTable()">
                            <span><i class="fas fa-plus"></i></span>
                        </button>
                        <ng-container *ngIf="this.database.tables!=null">
                            <div *ngFor="let table of this.database.tables" class="card mb-0">
                                <div class="card-header collapsed" data-toggle="collapse">
                                    <a class="btn btn-primary btn-sm" data-toggle="collapse" data-parent="#accordion"
                                       href="#{{table.name}}">
                                        <span><img class="tableImg" src="../../assets/images/DBTable.png"></span>
                                        <h6>
                                            {{table.name}}
                                        </h6>
                                    </a>
                                    <button id="btnRemoveAccordion" (click)="onRemoveTable(table.name)" type="button"
                                            class="btn btn-outline-danger btn-sm">Remove Table
                                    </button>
                                    <button id="btnRemoveAccordion" (click)="onEdit(table.name)" type="button"
                                            class="btn btn-outline-success btn-sm">Edit Table
                                    </button>
                                </div>
                                <div id="{{table.name}}" class="collapse">
                                    <div class="card card-body">
                                        <table>
                                            <thead>
                                            <th>Column name</th>
                                            <th>Type</th>
                                            </thead>
                                            <tr *ngFor="let col of table.columns">
                                                <td>{{col.name}}</td>
                                                <td>{{col.type}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <dbTableDefinition [database]="this.database" (databaseEvent)="refreshDB($event)"></dbTableDefinition>
        <generic-info-modal [hide]="_hideInfoModal" (OkClick)="onOk()"></generic-info-modal>`,
    styles:[`#btnRemoveAccordion{float: right;}.tableImg{width:50px;height:50px;}#emailConditions{margin-top:20px;}.dbImage{height:70px;}`]})
export class DatabaseComponent implements OnInit {

    @Input() database:Database;
    private _hideInfoModal = true;

    @ViewChild(DbTableDefinitionComponent) tableDefinition;
    @ViewChild (GenericModalComponent) private genericModal:GenericModalComponent;

    constructor(private _service:ProjectService) {

    }

    ngOnInit(): void {
        this._service.getDBDefinition(this.database.pId,this.database.qId,this.database.tId,this.database.terminalType).subscribe((dbDef:any)=> {
            this.database = new Database(dbDef);
        });
    }

    onCreateTable() {
        this.tableDefinition.hideTableDefinitionModal();
    }

    onRemoveTable(table: string) {
        this._service.deleteTable(table,this.database.pId,this.database.qId,this.database.tId,this.database.terminalType).subscribe((dbDef:any)=> {
            this.database.tables.splice(this.database.getTableIndex(table),1);
            this.genericModal.defineModal('Table has been deleted successfully.','Table Definition',200);

            this._hideInfoModal = !this._hideInfoModal;
        });
    }

    onEdit(name: string) {
        this.tableDefinition.edit(name);
    }

    refreshDB($event:Database) {
        this.database = $event;
    }

    onOk() {
        this._hideInfoModal=!this._hideInfoModal;
    }
}
